import { FC } from 'react';
import { ContentProcessVariableProps } from '../ProcessVariableCard.types';
import { ContentOutdated } from './ContentOutdated';
import { AllieButton, AllieText } from '../../../../components';
import {
  AllieTextCustomValueStyled,
  AllieTextValueStyled,
  ContentProcessVariableWrapper,
  ProcessVariableContentWrapper,
  StyledAllieChip,
} from '../ProcessVariableCard.styles';

export const ContentProcessVariable: FC<ContentProcessVariableProps> = ({
  favoriteView,
  fontColor,
  graphTrendPreview,
  range,
  machineName,
  value,
  statusText,
  borderChipColor,
  textOutdated,
  status,
  isCustomType,
  isMobile,
  showActionPlanButton,
  actionPlanButtonText,
  onClickActionPlanButton,
  withoutDataLabel,
}) => {
  const isOutdated = status === 'outdated';

  const handleClickActionPlanButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClickActionPlanButton && onClickActionPlanButton();
  };
  return (
    <>
      <ProcessVariableContentWrapper isMobile={isMobile} isOutdated={isOutdated}>
        {!isOutdated && (
          <ContentProcessVariableWrapper>
            {favoriteView && <AllieText>{machineName}</AllieText>}
            {!isOutdated &&
              (isCustomType ? (
                <AllieTextCustomValueStyled color={fontColor} type="body1" weight={600}>
                  {value}
                </AllieTextCustomValueStyled>
              ) : (
                <AllieTextValueStyled color={fontColor} type="h3" isMobile={isMobile}>
                  {value}
                </AllieTextValueStyled>
              ))}
            {statusText && (
              <StyledAllieChip
                outline
                corner="rounded"
                style={{ border: `1.5px solid var(--allie-color-${borderChipColor})` }}
              >
                <AllieText
                  type="body3"
                  color={fontColor}
                  weight={500}
                  style={{ textWrap: 'nowrap' }}
                >
                  {statusText}
                </AllieText>
              </StyledAllieChip>
            )}
            {!isOutdated && range && (
              <AllieText color="neutral-90" type="body3">
                {range}
              </AllieText>
            )}
          </ContentProcessVariableWrapper>
        )}
        {status === 'outdated' ? (
          <ContentOutdated text={textOutdated} title={withoutDataLabel} />
        ) : (
          graphTrendPreview
        )}
      </ProcessVariableContentWrapper>
      <div>
        {showActionPlanButton && (
          <AllieButton
            type="button"
            allieSize="xs"
            allieType="subtle"
            full
            corner="rounded-edges-plus"
            style={{ margin: 0, marginTop: 'var(--allie-spacing-md)' }}
            onClick={handleClickActionPlanButton}
          >
            <div className="action-plan-button-container">
              <img src="assets/icon-bg-fgpt.gif" />
              <AllieText type="button-small" color="neutral-70">
                {actionPlanButtonText}
              </AllieText>
            </div>
          </AllieButton>
        )}
      </div>
    </>
  );
};
